import React from "react";
import Lottie from "lottie-react";
import loadingAnimation from "../assets/animation/loadingAnimation.json";

const Loader = () => {
  return (
    <div style={{ width: "250px", height: "250px", margin: "0 auto 0 auto" }}>
      <Lottie
        animationData={loadingAnimation}
        loop={true}
        style={{
          width: "100%",
          height: "100%",
          scale: 1.5,
        }}
        // rendererSettings={{
        //   preserveAspectRatio: "xMidYMid slice",
        // }}
      />
    </div>
  );
};

export default Loader;
